module.exports = __webpack_public_path__ + "static/media/next.9e28c203.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons/next.svg
 ** module id = 378
 ** module chunks = 0
 **/